import { whiteColor } from "assets/jss/material-dashboard-react.js";

import dropdownStyle from "assets/jss/material-dashboard-react/dropdownStyle.js";

const tableviewStyle = (theme) => ({
  ...dropdownStyle(theme),
  search: {
    "& > div": {
      marginTop: "0",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "10px 15px !important",
      float: "none !important",
      paddingTop: "1px",
      paddingBottom: "1px",
      padding: "0!important",
      width: "60%",
      marginTop: "40px",
      "& input": {
        color: whiteColor,
      },
    },
  },
  table: {
    width: "100%",
    height: "100%",
    fontSize: "0.85vw",
    overflow: "auto",
    borderSpacing: "0",
  },
  tableview_th: {
    border: "0.1px solid #4f7edb",
    textAlign: "center",
  },
  tableview_td: {
    border: "0.1px solid #4f7edb",
    textAlign: "center",
  },
});

export default tableviewStyle;
